import React, {useState, useEffect} from 'react'
import BannerImg from '../assets/banner-img.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import Makeup from '../assets/makeup.jpg';
import Skincare from '../assets/skincare.jpg';
import Haircare from '../assets/haircare.jpg';
import Bodycare from '../assets/bodycare.jpg';
import BannerBg from '../assets/banner-bg.avif';
import {
  FaShoppingBasket,
  FaLeaf,
  FaTruck,
  FaArrowRight,
  FaAppleAlt,
  FaTags,
} from "react-icons/fa";
import {
  BsTruck,
  BsShieldCheck,
  BsLeaf,
  BsTags,
} from "react-icons/bs";

const Home = () => {
      const [banners, setBanners] = useState([]);

        useEffect(() => {
          const fetchBanners = async () => {
            try {
              const response = await fetch('https://api.hargharmart.com/get-banner');
              if (response.ok) {
                const data = await response.json();
                setBanners(data);
              } else {
                console.error('Failed to fetch banners');
              }
            } catch (error) {
              console.error('Error fetching banners:', error);
            }
          };
      
          fetchBanners();
        })
      

    return (
        <>

            {/* banner section */}
           <section className="banner-bg">
  <div className="container">
    <div className="row align-items-center">

      <div className="col-lg-6">
        <span className="banner-tag">
          <FaShoppingBasket className="me-2" />
          Fresh Grocery Store
        </span>

        <h1 className="banner-heading mt-3">
          Fresh Grocery <br />
          Delivered to <span>Your Home</span>
        </h1>

        <p className="banner-text mt-3">
          Shop fresh fruits, vegetables, dairy products, snacks and
          daily essentials with fast doorstep delivery.
        </p>

        {/* <div className="d-flex gap-3 mt-4 flex-wrap">
          <button className="shop-btn">
            Shop Now <FaArrowRight className="ms-2" />
          </button>

       
        </div> */}
        <div className="d-flex gap-3 mt-4 flex-wrap">
  <a
    href="https://play.google.com/store/apps/details?id=com.dectwin.satyam_store"
    target="_blank"
    rel="noopener noreferrer"
    className="text-decoration-none"
  >
    <button className="shop-btn">
      Shop Now <FaArrowRight className="ms-2" />
    </button>
  </a>
</div>

        <div className="row mt-5 g-3">

          <div className="col-4">
            <div className="feature-card">
              <FaLeaf className="feature-icon" />
              <h6>100% Fresh</h6>
              <p>Farm Fresh</p>
            </div>
          </div>

          <div className="col-4">
            <div className="feature-card">
              <FaTruck className="feature-icon" />
              <h6>Fast Delivery</h6>
              <p>30 Minutes</p>
            </div>
          </div>

          <div className="col-4">
            <div className="feature-card">
              <FaTags className="feature-icon" />
              <h6>Best Price</h6>
              <p>Daily Deals</p>
            </div>
          </div>

        </div>
      </div>

      <div className="col-lg-6 text-center position-relative">

        <img
          src={BannerImg}
          className="img-fluid banner-image"
          alt="Fresh Grocery"
        />

        {/* <div className="offer-card">
          <FaAppleAlt className="me-2" />
          Up to 40% OFF
        </div> */}

      </div>

    </div>
  </div>
</section>


            <div className='banner-bottom'>

            </div>
            {/* banner section ends */}



{/* Offer banner section */}
<section className='my-5 container'>
              <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
    <div className="carousel-indicators">
        {banners.length > 0 &&
            banners.map((offer, index) => (
                <button
                    key={index}
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={index}
                    className={index === 0 ? 'active' : ''}
                    aria-label={`Slide ${index + 1}`}
                ></button>
            ))
        }
    </div>

    <div className="carousel-inner rounded">
        {banners.length > 0 ? (
            banners.map((offer, index) => {
                const offerUrl = `https://api.hargharmart.com/uploads/${offer['image']}`;
                return (
                  <>
                    <div
                        key={index}
                        className={`carousel-item align-content-center ${index === 0 ? 'active' : ''} banner2-bg`}
                        style={{ 
    backgroundImage: `
      linear-gradient(rgba(0, 0, 0, 0.10), rgba(0, 0, 0, 0.70)), 
      url(${offerUrl || BannerBg})
    `,
    // backgroundSize: 'cover',
    // backgroundPosition: 'center',
    // backgroundRepeat: 'no-repeat'
  }}
                    >
                        <div className="container">
                            <p className="banner-text fw-semibold text-light">{offer.offer_tagline}</p>
                            <p className="banner-heading col-md-8 text-light">{offer.offer_name}</p>
                            <p className="col-lg-6 col-md-8 fm-spartan text-light">{offer.description}</p>
                        </div>
                    </div>
                    </>
                );
            })
        ) : (
            <div className="carousel-item active banner2-bg" style={{ backgroundImage: `url(${BannerBg})`}}>
                <div className="container">
                    <p className="banner-text fw-semibold">Get Exciting Deals & Discounts</p>
                    <p className="banner-heading col-md-8">Refine your Beauty</p>
                    <p className="col-lg-6 col-md-8 fm-spartan">
                      Whether you're looking to refresh your skincare routine, try the latest makeup trends, or indulge in self-care, we’ve got you covered.
                    </p>
                </div>
            </div>
        )}
    </div>
</div>
</section>
{/* offer banner section ends */}


            {/* Popular category section */}
          <section className="bg-light py-5">
  <div className="container">

    <p className="sec-heading text-center mb-4">
      Shop by Categories
    </p>

    <Swiper
      spaceBetween={30}
      slidesPerView={3}
      modules={[Autoplay, Navigation]}
      loop={true}
      className="py-3 px-md-5 px-2"
      navigation={{
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }}
      autoplay={{ delay: 2500 }}
      breakpoints={{
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      }}
    >
      {/* Fresh Vegetables */}
      <SwiperSlide>
        <div className="category-area">
          <img
            src="https://images.unsplash.com/photo-1542838132-92c53300491e?w=800"
            alt="Fresh Vegetables"
            className="category-img"
          />

          <div className="category-content">
            <p className="category-text">Fresh Vegetables</p>

            <p className="text-muted">
              Farm fresh vegetables including tomatoes, onions, potatoes,
              spinach, cabbage, carrots and more.
            </p>

            <hr />
          </div>
        </div>
      </SwiperSlide>

      {/* Fresh Fruits */}
      <SwiperSlide>
        <div className="category-area">
          <img
            src="https://images.unsplash.com/photo-1619566636858-adf3ef46400b?w=800"
            alt="Fresh Fruits"
            className="category-img"
          />

          <div className="category-content">
            <p className="category-text">Fresh Fruits</p>

            <p className="text-muted">
              Apples, bananas, mangoes, oranges, grapes, pomegranates,
              seasonal fruits and more.
            </p>

            <hr />
          </div>
        </div>
      </SwiperSlide>

      {/* Dairy */}
      <SwiperSlide>
        <div className="category-area">
          <img
            src="https://images.unsplash.com/photo-1550583724-b2692b85b150?w=800"
            alt="Dairy Products"
            className="category-img"
          />

          <div className="category-content">
            <p className="category-text">Dairy Products</p>

            <p className="text-muted">
              Milk, butter, cheese, curd, paneer, cream, yogurt and other
              fresh dairy essentials.
            </p>

            <hr />
          </div>
        </div>
      </SwiperSlide>

      {/* Grocery Essentials */}
      <SwiperSlide>
        <div className="category-area">
          <img
            src="https://images.unsplash.com/photo-1586201375761-83865001e31c?w=800"
            alt="Grocery Essentials"
            className="category-img"
          />

          <div className="category-content">
            <p className="category-text">Grocery Essentials</p>

            <p className="text-muted">
              Rice, flour, pulses, spices, cooking oil, sugar, salt and daily
              household essentials.
            </p>

            <hr />
          </div>
        </div>
      </SwiperSlide>

      {/* Beverages */}
      <SwiperSlide>
        <div className="category-area">
          <img
            src="https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800"
            alt="Beverages"
            className="category-img"
          />

          <div className="category-content">
            <p className="category-text">Beverages</p>

            <p className="text-muted">
              Tea, coffee, juices, soft drinks, energy drinks and healthy
              beverages.
            </p>

            <hr />
          </div>
        </div>
      </SwiperSlide>

      {/* Snacks */}
      <SwiperSlide>
        <div className="category-area">
          <img
            src="https://images.unsplash.com/photo-1515003197210-e0cd71810b5f?w=800"
            alt="Snacks"
            className="category-img"
          />

          <div className="category-content">
            <p className="category-text">Snacks & Biscuits</p>

            <p className="text-muted">
              Chips, namkeen, cookies, chocolates, biscuits and ready-to-eat
              snacks.
            </p>

            <hr />
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  </div>
</section>
            {/* Popular category section ends */}


{/* banner2 section */}
<section className="banner2-bg">
  <div className="container text-center">

    <p className="banner-text">
      Fresh Groceries Delivered
    </p>

    <h2 className="banner-heading">
      Farm Fresh Fruits, Vegetables & Daily Essentials
    </h2>

    <p className="banner-subtitle" style={{color:"#121212"}}>
      Shop from thousands of quality products at the best prices with fast and reliable delivery.
    </p>

    <button
      className="banner2-btn animate__animated animate__pulse animate__infinite"
      onClick={() =>
        window.open(
          "https://play.google.com/store/apps/details?id=com.dectwin.satyam_store",
          "_blank"
        )
      }
    >
      Shop Now
    </button>

  </div>
</section>

<section className="why-us py-5">
  <div className="container">

    <div className="text-center mb-5">
      <p className="section-subtitle">Why Choose Us</p>
      <h2 className="section-title">
        Everything You Need, Delivered Fresh
      </h2>
    </div>

    <div className="row g-4">

      {/* Fast Delivery */}
      <div className="col-lg-3 col-md-6">
        <div className="feature-card">
          <BsTruck size={45} className="feature-icon" />
          <h5>Fast Delivery</h5>
          <p>
            Get your groceries delivered quickly to your doorstep with reliable service.
          </p>
        </div>
      </div>

      {/* Fresh Products */}
      <div className="col-lg-3 col-md-6">
        <div className="feature-card">
          <BsLeaf size={45} className="feature-icon" />
          <h5>Fresh Products</h5>
          <p>
            Farm-fresh fruits, vegetables and quality groceries every day.
          </p>
        </div>
      </div>

      {/* Best Prices */}
      <div className="col-lg-3 col-md-6">
        <div className="feature-card">
          <BsTags size={45} className="feature-icon" />
          <h5>Best Prices</h5>
          <p>
            Enjoy amazing discounts and affordable prices on every order.
          </p>
        </div>
      </div>

      {/* Secure Payment */}
      <div className="col-lg-3 col-md-6">
        <div className="feature-card">
          <BsShieldCheck size={45} className="feature-icon" />
          <h5>Secure Payment</h5>
          <p>
            Multiple safe payment options with a hassle-free shopping experience.
          </p>
        </div>
      </div>

    </div>

  </div>
</section>
{/* banner2 section ends */}

        </>
    )
}

export default Home
